/* ============================================================
   YOUNGER 首頁 — interactions (Shopify theme)
   Content grids are rendered server-side in Liquid; this file
   only drives motion, the dual-video hero, and small mocks.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- glass-liquid nav (float + on-light on scroll) ---------- */
  var nav = document.getElementById('nav');
  var navLogo = document.getElementById('navLogo');
  if (nav) {
    var logoLight = nav.getAttribute('data-logo-light') || '';
    var logoDark = nav.getAttribute('data-logo-dark') || '';
    // 深色底區塊（用專屬屬性，避免與 Minimog 的 .hero 撞名）
    var darkEls = document.querySelectorAll('[data-bd-dark]');
    var heroEl = document.querySelector('.hero') || darkEls[0] || null;
    var onScroll = function () {
      var y = window.scrollY;
      nav.classList.toggle('float', y > 40);
      // nav 實際所在的垂直帶；任何深色區與它重疊 -> 白色
      var nr = nav.getBoundingClientRect();
      var navTop = nr.top, navBot = nr.bottom;
      // docked：hero 已捲到 nav 上方 -> 收成貼頂的實心淺色長條
      var docked = heroEl ? (heroEl.getBoundingClientRect().bottom <= navBot) : false;
      nav.classList.toggle('docked', docked);
      var overDark = false;
      for (var i = 0; i < darkEls.length; i++) {
        var r = darkEls[i].getBoundingClientRect();
        if (r.top <= navBot && r.bottom >= navTop) { overDark = true; break; }
      }
      var onLight = docked || !overDark;
      nav.classList.toggle('on-light', onLight);
      if (navLogo && logoLight && logoDark) {
        navLogo.src = onLight ? logoLight : logoDark;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile drawer (slides in from the right) ---------- */
  var burgerBtn = document.getElementById('navMenuBtn');
  var mnav = document.getElementById('mnav');
  var mnavScrim = document.getElementById('mnavScrim');
  var mnavClose = document.getElementById('mnavClose');
  if (burgerBtn && mnav) {
    var setDrawer = function (open) {
      mnav.classList.toggle('open', open);
      mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (mnavScrim) {
        mnavScrim.classList.toggle('open', open);
        if (open) { mnavScrim.removeAttribute('hidden'); } else { mnavScrim.setAttribute('hidden', ''); }
      }
      document.body.classList.toggle('menu-open', open);
      burgerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    burgerBtn.addEventListener('click', function () { setDrawer(!mnav.classList.contains('open')); });
    if (mnavClose) mnavClose.addEventListener('click', function () { setDrawer(false); });
    if (mnavScrim) mnavScrim.addEventListener('click', function () { setDrawer(false); });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mnav.classList.contains('open')) { setDrawer(false); }
    });
  }

  /* ---------- 全球佈局 map-card push gallery ---------- */
  var gcTrack = document.getElementById('gcTrack');
  var gcPrev = document.getElementById('gcPrev');
  var gcNext = document.getElementById('gcNext');
  if (gcTrack && gcPrev && gcNext) {
    var gcIdx = 0;
    var gcMetrics = function () {
      var cards = gcTrack.children;
      var n = cards.length;
      if (!n) return { step: 0, maxIdx: 0 };
      var w = cards[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(gcTrack).columnGap || getComputedStyle(gcTrack).gap) || 18;
      var step = w + gap;
      var vp = (gcTrack.parentElement || gcTrack).getBoundingClientRect().width;
      // 完整可見的卡片數；每次點擊固定推進一張卡（step），最後一張對齊不會出現半張
      var visible = Math.max(1, Math.floor((vp + gap) / step));
      return { step: step, maxIdx: Math.max(0, n - visible) };
    };
    var gcUpdate = function () {
      var m = gcMetrics();
      if (gcIdx < 0) gcIdx = 0;
      if (gcIdx > m.maxIdx) gcIdx = m.maxIdx;
      gcTrack.style.transform = 'translateX(-' + (gcIdx * m.step) + 'px)';
      gcPrev.disabled = gcIdx <= 0;
      gcNext.disabled = gcIdx >= m.maxIdx;
    };
    // 自動輪播：每 3.4s 推進一張，到最後一張後回到第一張；hover/聚焦時暫停；尊重 reduce-motion
    var gcBand = gcTrack.closest('.bd-footprint-band') || gcTrack;
    var gcTimer = null;
    var gcInView = false;
    var gcReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gcAdvance = function () {
      var m = gcMetrics();
      if (m.maxIdx <= 0) return;
      gcIdx = (gcIdx >= m.maxIdx) ? 0 : gcIdx + 1;
      gcUpdate();
    };
    var gcStop = function () { if (gcTimer) { clearInterval(gcTimer); gcTimer = null; } };
    var gcStart = function () {
      if (gcReduce || gcTimer || !gcInView) return;
      if (gcMetrics().maxIdx <= 0) return;
      gcTimer = setInterval(gcAdvance, 3400);
    };
    gcPrev.addEventListener('click', function () { gcIdx--; gcUpdate(); gcStop(); gcStart(); });
    gcNext.addEventListener('click', function () { gcIdx++; gcUpdate(); gcStop(); gcStart(); });
    gcBand.addEventListener('mouseenter', gcStop);
    gcBand.addEventListener('mouseleave', gcStart);
    gcBand.addEventListener('focusin', gcStop);
    gcBand.addEventListener('focusout', gcStart);
    window.addEventListener('resize', function () { gcIdx = 0; gcUpdate(); }, { passive: true });
    gcUpdate();
    // 進畫面才開始自動輪播：用捲動事件判斷（與 bd-about 同慣例，不用 IntersectionObserver）
    var gcIsInView = function () {
      var r = gcBand.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return r.top < vh * 0.85 && r.bottom > vh * 0.15;
    };
    var gcRaf = false;
    var gcSyncView = function () {
      gcRaf = false;
      var now = gcIsInView();
      if (now && !gcInView) { gcInView = true; gcStart(); }
      else if (!now && gcInView) { gcInView = false; gcStop(); }
    };
    var gcOnScroll = function () { if (!gcRaf) { gcRaf = true; requestAnimationFrame(gcSyncView); } };
    window.addEventListener('scroll', gcOnScroll, { passive: true });
    window.addEventListener('resize', gcOnScroll);
    gcSyncView();
  }

  var playSvg = '<svg viewBox="0 0 24 24"><path d="M7 5v14l12-7z"/></svg>';
  var pauseSvg = '<svg viewBox="0 0 24 24"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';

  /* ---------- hero: dual-video seamless loop ---------- */
  var heroPlaying = true;
  var heroPause = document.getElementById('heroPause');
  var v1 = document.getElementById('heroVid1');
  var v2 = document.getElementById('heroVid2');
  var heroVids = [v1, v2].filter(Boolean);
  var curVid = 0;
  function swapVid() {
    if (heroVids.length < 2) return;
    var now = heroVids[curVid];
    var next = heroVids[(curVid + 1) % heroVids.length];
    next.currentTime = 0;
    if (heroPlaying) next.play().catch(function () {});
    next.classList.add('active');
    now.classList.remove('active');
    curVid = (curVid + 1) % heroVids.length;
  }
  heroVids.forEach(function (v) { v.loop = (heroVids.length < 2); v.addEventListener('ended', swapVid); });
  if (v1) v1.play().catch(function () {});
  if (heroPause) {
    heroPause.addEventListener('click', function () {
      heroPlaying = !heroPlaying;
      heroPause.innerHTML = heroPlaying ? pauseSvg : playSvg;
      var active = heroVids[curVid];
      if (active) { heroPlaying ? active.play().catch(function () {}) : active.pause(); }
    });
  }

  /* 手機版：米白數據塊是 hero 的最後一段，暫停鈕(絕對定位於 .hero)會壓到它。
     量出它的高度寫成 --hero-stats-h，CSS 就能把按鈕頂到它上方，不必寫死數字。 */
  var heroEl = document.querySelector('#MainContent.bd-home .hero');
  var heroStats = heroEl && heroEl.querySelector('.hero-stats');
  if (heroEl && heroStats) {
    var syncStatsH = function () {
      heroEl.style.setProperty('--hero-stats-h', Math.round(heroStats.getBoundingClientRect().height) + 'px');
    };
    syncStatsH();
    window.addEventListener('resize', syncStatsH, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(syncStatsH).observe(heroStats);
  }

  /* ---------- disease marquee (built from data attribute) ---------- */
  var monStage = document.getElementById('monStage');
  var dzTrack1 = document.getElementById('dzTrack1');
  var dzTrack2 = document.getElementById('dzTrack2');
  if (dzTrack1 && dzTrack2 && monStage) {
    var raw = monStage.getAttribute('data-diseases') || '';
    var diseases = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    var rowHTML = function (arr) {
      var one = arr.map(function (d) { return '<span>' + d + '</span><span class="sep">·</span>'; }).join('');
      return one + one;
    };
    var half = Math.floor(diseases.length / 2);
    var b = diseases.slice(half).concat(diseases.slice(0, half));
    dzTrack1.innerHTML = rowHTML(diseases);
    dzTrack2.innerHTML = rowHTML(b);
  }
  var dzPause = document.getElementById('dzPause');
  var dzPlaying = true;
  if (dzPause && monStage) {
    dzPause.addEventListener('click', function () {
      dzPlaying = !dzPlaying;
      monStage.classList.toggle('paused', !dzPlaying);
      dzPause.innerHTML = (dzPlaying ? pauseSvg : playSvg) + (dzPlaying ? ' 暫停動態' : ' 播放動態');
    });
  }

  /* ---------- taiwan map dots (decorative mock) ---------- */
  var tw = document.getElementById('twMap');
  if (tw) {
    var dots = '';
    for (var i = 0; i < 70; i++) {
      var x = 28 + Math.random() * 44;
      var y = 8 + Math.random() * 104;
      var w = 22 + 18 * Math.sin((y / 120) * Math.PI);
      if (Math.abs(x - 50) < w / 2) {
        var op = 0.35 + Math.random() * 0.5;
        dots += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="2.1" fill="var(--accent)" opacity="' + op.toFixed(2) + '"/>';
      }
    }
    tw.innerHTML = dots;
  }

  /* ---------- gold bars (decorative mock) ---------- */
  var bars = document.getElementById('gsBars');
  if (bars) {
    var html = '';
    for (var j = 0; j < 13; j++) { html += '<i style="height:' + (18 + j * 6.2) + '%"></i>'; }
    bars.innerHTML = html;
  }

  /* ---------- partner overlay popup ---------- */
  function bdCloseOverlay(ov) {
    if (!ov) return;
    ov.classList.remove('open');
    ov.setAttribute('hidden', '');
    document.body.classList.remove('menu-open');
  }
  document.querySelectorAll('[data-bd-popup]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ov = document.getElementById(btn.getAttribute('data-bd-popup'));
      if (ov) { ov.removeAttribute('hidden'); ov.classList.add('open'); document.body.classList.add('menu-open'); }
    });
  });
  document.querySelectorAll('.bd-overlay [data-bd-close]').forEach(function (el) {
    el.addEventListener('click', function () { bdCloseOverlay(el.closest('.bd-overlay')); });
  });
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bd-overlay.open').forEach(function (ov) { bdCloseOverlay(ov); });
    }
  });

  /* ---------- count-up 數字（gold stats，#7/#8）---------- */
  var countEls = document.querySelectorAll('.gs-big[data-countup]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function renderCount(el, val, prefix, suffix) {
    var s = suffix ? '<span class="gs-plus">' + suffix + '</span>' : '';
    el.innerHTML = prefix + Number(val).toLocaleString() + s;
  }
  function runCount(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/([\d,]+)/);
    if (!m) { el.classList.add('done'); return; }
    var numStr = m[1];
    var target = parseInt(numStr.replace(/,/g, ''), 10);
    var idx = raw.indexOf(numStr);
    var prefix = raw.slice(0, idx);
    var suffix = raw.slice(idx + numStr.length);
    if (reduceMotion) { renderCount(el, target, prefix, suffix); el.classList.add('done'); return; }
    var start = target >= 100 ? Math.round(target * 0.8) : Math.max(0, target - 9);
    renderCount(el, start, prefix, suffix);
    var dur = 1500, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      var val = Math.round(start + (target - start) * e);
      renderCount(el, val, prefix, suffix);
      if (p < 1) { requestAnimationFrame(step); } else { el.classList.add('done'); }
    }
    requestAnimationFrame(step);
  }
  if (countEls.length) {
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } });
      }, { threshold: 0.4 });
      countEls.forEach(function (el) { cio.observe(el); });
    } else {
      countEls.forEach(runCount);
    }
  }

  /* ---------- 生物標記卡數值 count-up（小數，放慢）---------- */
  var floatEls = document.querySelectorAll('.bm-val[data-countup-float]');
  function runFloat(el) {
    var target = parseFloat((el.textContent || '').trim());
    if (isNaN(target) || reduceMotion) { return; }
    var dur = 1300, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * e).toFixed(2);
      if (p < 1) { requestAnimationFrame(step); } else { el.textContent = target.toFixed(2); }
    }
    requestAnimationFrame(step);
  }
  if (floatEls.length) {
    if ('IntersectionObserver' in window) {
      var fio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var el = e.target; setTimeout(function () { runFloat(el); }, 300); fio.unobserve(el); } });
      }, { threshold: 0.4 });
      floatEls.forEach(function (el) { fio.observe(el); });
    }
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
})();

/* ============ 真實見證 YouTube 彈窗（內嵌播放，不離站）============ */
(function () {
  var modal = document.getElementById('bdVidModal');
  var frame = document.getElementById('bdVidFrame');
  var titleEl = document.getElementById('bdVidTitle');
  if (!modal || !frame) return;
  function ytId(u) { var m = (u || '').match(/(?:youtu\.be\/|[?&]v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/); return m ? m[1] : ''; }
  function openVid(url, title) {
    var id = ytId(url); if (!id) return false;
    frame.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    if (titleEl) titleEl.textContent = title || '';
    modal.removeAttribute('hidden'); document.body.classList.add('menu-open'); return true;
  }
  function closeVid() { frame.src = ''; modal.setAttribute('hidden', ''); document.body.classList.remove('menu-open'); }
  document.querySelectorAll('.vid-card[data-yt]').forEach(function (card) {
    card.addEventListener('click', function (e) { if (openVid(card.getAttribute('data-yt'), card.getAttribute('data-yt-title'))) e.preventDefault(); });
  });
  modal.querySelectorAll('[data-vid-close]').forEach(function (el) { el.addEventListener('click', closeVid); });
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeVid(); });
})();
